import type { ApiClient } from '../../api/client';
import type { DocumentsPort } from '../../features/documents/public';

export function createDocumentsHttpAdapter(client: ApiClient): DocumentsPort {
  return {
    async searchPersonSubjects(query) {
      const normalizedQuery = query.trim().toLocaleLowerCase();
      return (await client.listPeopleReferences()).data
        .map((person) => ({ id: person.id, name: person.descriptor || '이름 미등록' }))
        .filter((person) => person.name.toLocaleLowerCase().includes(normalizedQuery));
    },
    async list(subject) {
      return (await client.listDocuments(subject)).data;
    },
    get(id) {
      return client.getDocument(id);
    },
    download(id) {
      return client.downloadDocument(id);
    },
    async upload(input) {
      return client.uploadDocument(input);
    },
  };
}
